import React from 'react'
// @ts-ignore
import TimeGrid from 'react-big-calendar/lib/TimeGrid'
import addDays from 'date-fns/addDays'
import startOfDay from 'date-fns/startOfDay'
import isBefore from 'date-fns/isBefore'
import isEqual from 'date-fns/isEqual'
import { NavigateAction, WeekProps } from 'react-big-calendar'

export class CustomCalendarView extends React.Component<WeekProps> {
  static range: (date: Date) => Date[]
  static navigate: (date: Date, action: NavigateAction) => Date
  static title: (date: Date) => string
  render() {
    const { date } = this.props
    const range = CustomCalendarView.range(date)

    return <TimeGrid {...this.props} range={range} eventOffset={15} />
  }
}

CustomCalendarView.title = (date: Date) => date.toString()
CustomCalendarView.range = (date: Date) => {
  const start = new Date()
  const end = addDays(start, 2)
  let current = startOfDay(start)
  const range = []
  while (isBefore(current, end) || isEqual(current, end)) {
    range.push(current)
    current = addDays(current, 1)
  }
  return range
}

export default CustomCalendarView
